import { apiTryFetchRetry } from '@editor/utils/apiFetchRetry';
import type { SharedConfig } from '@repo/api-client';

import { GenericApiResponse } from '../types';

import { USER_API_URL } from './constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createAPI = ({ url }: { url: string }) => {
  type SharedConfigResponse = GenericApiResponse<{
    config: SharedConfig;
  }>;

  const index = async (): Promise<SharedConfigResponse> => {
    return await apiTryFetchRetry(`${url}/index`, {
      method: 'GET',
    });
  };

  return {
    index,
  };
};

export default createAPI({ url: `${USER_API_URL}/config` });
